import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { InteractiveMapIcon } from '../Icons/ViewIcons'

const PositionModal = (): JSX.Element => {
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)

  return (
    <div className='rf-max-w-[500px] rf-px-8 rf-py-8 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4 rf-text-size-auto'>
      <InteractiveMapIcon className='rf-h-10' color='#FFF' />
      <p className='rf-font-light'>{translation.position.rejected}</p>
      <p className='rf-text-center'>{translation.position.instructions}</p>
    </div>
  )
}

export default PositionModal
